import controller from './kform.controller';
import template from './kform.html';

export default {
	template,
	bindings:     {
		create:         '<',
		forms:          '=?',
		kid:            '<',
		loading:        '=?',
		name:           '=',
		onBeforeSubmit: '&?',
		onCancel:       '&?',
		onSubmit:       '&?',
		options:        '<?',
		row:            '<?',
		tab:            '<?',
	},
	controller,
	controllerAs: '$ctrl',
};
